import { Injectable } from "@angular/core";
import { Http } from "@angular/http";

import { BaseService } from "./base.service";
import { ReportSettings } from "../home/report-builder/report-builder.component";
import { DataDictionaryService } from "./data-dictionary.service";

@Injectable()
export class ReportService extends BaseService {
  constructor(protected http: Http) {
    super(http);
  }

  async getReport(reportId: string): Promise<Array<any>> {
    return this.get("report/" + reportId);
  }

  async buildReport(settings: ReportSettings): Promise<string> {
    return this.post("report", settings);
  }

  async downloadConsolidatedSheet(topLevelSheetId: string): Promise<string> {
    return this.get("report/consolidated/" + topLevelSheetId);
  }

  async getAdminNhorV4Report(): Promise<any> {
    return this.get("report/admin/nhor_v4");
  }
}



// WEBPACK FOOTER //
// ./src/app/services/report.service.ts